<!-- 表格序号组件 -->
<template>
    <div class="tableSort">
        <div class="text-ellipse" v-if="String(index + (page -1) * pagesize + 1).length <= 6">{{index + (page -1) * pagesize + 1}}</div>
        <el-tooltip class="item" v-else effect="dark" :content="String(index + (page -1) * pagesize + 1)" placement="top">
            <div class="text-ellipse">{{index + (page -1) * pagesize + 1}}</div>
        </el-tooltip>
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    props: {
        index: {
            required: true,
            type: Number,
            default: 0
        },
        page: {
            required: true,
            type: Number,
            default: 1
        },
        pagesize: {
            required: true,
            type: Number,
            default: 20
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {

    }
}
</script>
<style scoped lang='scss'>
/* @import url(); 引入css类 */

</style>